import {
  Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis,
} from "recharts";

/** A weight log, drawn and nothing more.
 *
 *  No target line, no goal band, no colour that means "good" or "bad", no arrows. The
 *  chart shows what happened; the clinician supplies the meaning. A plateau is the thing
 *  weight-loss patients actually struggle with, and a red zone around it helps nobody.
 */

const SLATE = "#1E293B";

function shortDate(iso) {
  if (!iso) return "";
  return new Date(`${iso}T12:00:00Z`).toLocaleDateString(undefined, {
    month: "short", day: "numeric", timeZone: "UTC",
  });
}

export default function WeightChart({ entries, unit = "lb", height = 200 }) {
  if (!entries || entries.length < 2) return null;
  const data = entries.map((e) => ({ date: e.recorded_on, value: e.value }));
  return (
    <div style={{ height }} className="-ml-2" data-testid="weight-chart">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 6, right: 10, bottom: 0, left: 0 }}>
          <XAxis dataKey="date" tickFormatter={shortDate} tickLine={false}
                 axisLine={false} tick={{ fontSize: 11, fill: "#64748B" }} />
          <YAxis width={44} tickLine={false} axisLine={false}
                 tick={{ fontSize: 11, fill: "#64748B" }} domain={["auto", "auto"]} />
          <Tooltip labelFormatter={shortDate}
                   formatter={(v) => [`${v} ${unit}`, "Weight"]}
                   contentStyle={{ fontSize: 12, borderRadius: 8, border: "1px solid #E2E8F0" }} />
          <Line type="monotone" dataKey="value" stroke={SLATE} strokeWidth={2}
                dot={{ r: 3, fill: SLATE }} activeDot={{ r: 4 }} isAnimationActive={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
